export default __webpack_public_path__ + "static/media/odinLogo1.d2678da9.png";